import { Component, AfterViewInit } from '@angular/core';
import Swiper from 'swiper';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';

Swiper.use([Pagination, Autoplay, Navigation]);

@Component({
    selector: 'fe-carousel-cars',
    templateUrl: './carousel-cars.component.html',
    styleUrls: ['./carousel-cars.component.scss'],
})
export class CarouselCarsComponent implements AfterViewInit {
    vehiculos = [
        {
            tipo: 'fe_lp_autos_type_1',
            modelo: 'fe_lp_autos_model_1',
            transmision: 'fe_lp_autos_transmission_1',
            pasajeros: 5,
            maletas: 5,
            imagen: 'images/vehiculo-jetta.png',
        },
        {
            tipo: 'fe_lp_autos_type_2',
            modelo: 'fe_lp_autos_model_2',
            transmision: 'fe_lp_autos_transmission_1',
            pasajeros: 5,
            maletas: 4,
            imagen: 'images/vehiculo-aveo.png',
        },
        {
            tipo: 'fe_lp_autos_type_3',
            modelo: 'fe_lp_autos_model_3',
            transmision: 'fe_lp_autos_transmission_1',
            pasajeros: 4,
            maletas: 3,
            imagen: 'images/vehiculo-march.png',
        },
    ];

    ngAfterViewInit(): void {
        setTimeout(() => {
            new Swiper('.vehiculos-swiper', {
                loop: true,
                spaceBetween: 20,
                slidesPerView: 1,
                navigation: {
                    nextEl: '.vehiculo-button-next',
                    prevEl: '.vehiculo-button-prev',
                },
                breakpoints: {
                    768: { slidesPerView: 2 },
                    992: { slidesPerView: 3 },
                },
            });
        }, 100);
    }
}
